module.exports = __webpack_public_path__ + "img/contact.a3b1ff5a.svg";